import React, {useMemo} from 'react';

import {Skeleton} from 'src/components/skeleton';
import {useLicenseTypes} from 'src/hooks/dictionaries';

import Button from '@pb/kit-component-button';
import {Popover} from '@pb/kit-component-dropdown';
import {Group} from '@pb/kit-component-group';
import {Icon, Icons} from '@pb/kit-component-icon';


import {DefaultLimitsPopoverContent} from '../components/default-limit-popover-content';

import {ResetLimitsSkeleton} from './reset-default-limits.skeleton';

import type {LicenseType} from 'src/openapi/admin/models/LicenseType';
import type {Limit} from 'src/openapi/admin/models/Limit';

type Props = {
    licenseType?: LicenseType,
    isDefaultUsageLimits: boolean,
    loading: boolean,
    defaultUsageLimits: Array<Limit> | null,
    disabled?: boolean,
    onReset: () => void,
};

export const ResetDefaultLimitsSection = (props: Props) => {
    const {licenseType, isDefaultUsageLimits, defaultUsageLimits, loading, onReset, disabled} = props;
    const {getLicenseTypeByCode} = useLicenseTypes();

    const description = useMemo(() => (
        licenseType ? getLicenseTypeByCode(licenseType) : ''
    ), [licenseType, getLicenseTypeByCode]);

    return (
        <Skeleton view={<ResetLimitsSkeleton/>} shown={loading || !description}>
            <Group>
                <Button
                    variant="Type.SECONDARY"
                    disabled={disabled || isDefaultUsageLimits}
                    onClick={onReset}>
                    Use default limits
                </Button>
                {isDefaultUsageLimits ? (
                    <div>
                        Currently using default limits for <b>{description}</b> license type.
                    </div>
                ) : (
                    <div>
                        <b>Currently using custom limits.</b> Reset to defaults for
                        the <b>{description}</b> license
                        type.&nbsp;
                        <Popover
                            anchor={({anchorRef, getAnchorProps}) => (
                                <span ref={anchorRef} {...getAnchorProps()}>
                                    <Icon type={Icons.INFO}/>
                                </span>
                            )}>
                            <DefaultLimitsPopoverContent {...{description, defaultUsageLimits}}/>
                        </Popover>
                    </div>
                )}
            </Group>
        </Skeleton>
    );
};
